Ext.define('Ext.ux.grid.GridPanelExdNew', {
    extend: 'Ext.grid.GridPanel',
    alias: 'widget.gridpanelexdnew',
    preserveScrollAll: true,
    enableTextSelection: true,
    enableColumnHide: false,
    enableColumnMove: false,
    enableHdMenu: false,

    initComponent: function () {
        this.viewConfig = this.viewConfig || {};
        Ext.applyIf(this.viewConfig, {
            preserveScrollOnRefresh: this.preserveScrollAll,
            preserveScrollOnReload: this.preserveScrollAll,
            enableTextSelection: this.enableTextSelection,
            emptyText: `<div class="grid-empty-text">${Lang.no_records}</div>`,
            deferEmptyText: false
        });
        this.dockedItems = this.dockedItems || [];
        let isMobile = Ext.os.is.Phone && (Config.mobileuidisabled != 1);
        this.dockedItems.push({
            xtype: 'pagingtoolbarexdnew',
            prefix: this.prefix,
            dock: 'top',
            mobilePartTop: isMobile,
            pagingStore: this.store,
            store: this.store,
            displayInfo: true,
            grid: this
        })
        if (isMobile) {
            this.dockedItems.push({
                xtype: 'pagingtoolbarexdnew',
                dock: 'top',
                prefix: this.prefix,
                mobilePartBottom: true,
                pagingStore: this.store,
                store: this.store,
                displayInfo: true,
                grid: this
            });
        }
        this.activeFiltersPanel = Ext.create('ActiveFiltersPanel', {
            dock: 'top'
        });
        this.dockedItems.push(this.activeFiltersPanel);
        this.callParent(arguments);

        this.store.on('filterchange', () => {
            if (this.activeFiltersPanel?.updateFilters) {
                this.activeFiltersPanel.updateFilters(this.store, this);
            }
        });

        this.on('afterrender', () => {
            Ext.defer(() => {
                if (this.activeFiltersPanel) {
                    if (this.activeFiltersPanel?.updateFilters) {
                        this.activeFiltersPanel.updateFilters(this.store, this);
                    }
                }
            }, 200);
        });
    },

    getState: function() {
        const me = this;
        const state = me.callParent ? me.callParent() : {};
        const filters = me.getStore().getFilters().items
            .filter(f => f.getProperty() !== 'fastSearch')
            .map(f => ({
                property: f.getProperty(),
                value: f.getValue(),
                operator: f.getOperator?.()
            }));
        return Ext.apply({}, state, {
            filters: filters
        });
    },

    applyState: function(state) {
        const me = this;
        me.callParent(arguments);
        if (state.filters) {
            const filters = state.filters.map(f => {
                if (!f.id) {
                    f.id = `${f.property}-${f.operator || '='}`;
                }
                return f;
            });
            me.getStore().setFilters(filters);
        }
    }
});